var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPinUpright = function SvgPinUpright(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11 18.598V15h2v3.598C13 20.5 12.238 22 12 22s-1-1.5-1-3.402M9.5 6c-.325-.167-1.714-.8-2.883-2s-.495-2 .513-2H12v4zM14.5 6c.325-.167 1.714-.8 2.883-2s.495-2-.513-2H12v4zM9.429 6h5.142L15 10H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 9c-3.069 0-5.676 1.693-6.621 4.048C4.967 14.073 5.895 15 7 15h10c1.105 0 2.032-.927 1.621-1.952C17.677 10.693 15.07 9 12 9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPinUpright);
export { ForwardRef as Icon };
export default "img/element-icons/room/pin-upright.340b3b6.svg";